window.loadSlick = window.loadSlick || function () {

  if (
    window.jQuery &&
    window.jQuery.fn &&
    window.jQuery.fn.slick
  ) {
    return Promise.resolve();
  }

  if (window.__slickLoading) {
    return window.__slickLoading;
  }

  window.__slickLoading = new Promise(function (resolve, reject) {

    function loadScript(src) {
      return new Promise(function (resolveScript, rejectScript) {

        const script = document.createElement('script');

        script.src = src;

        script.onload = resolveScript;
        script.onerror = rejectScript;

        document.head.appendChild(script);

      });
    }

    function loadCSS() {

      if (
        document.querySelector(
          'link[data-slick-css]'
        )
      ) {
        return;
      }

      const link = document.createElement('link');

      link.rel = 'stylesheet';

      link.href =
        'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css';

      link.dataset.slickCss = 'true';

      document.head.appendChild(link);
    }


    loadCSS();


    const jqueryPromise =
      window.jQuery
        ? Promise.resolve()
        : loadScript(
            'https://code.jquery.com/jquery-3.7.1.min.js'
          );


    jqueryPromise
      .then(function () {

        if (
          window.jQuery &&
          window.jQuery.fn &&
          window.jQuery.fn.slick
        ) {
          return;
        }

        return loadScript(
          'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js'
        );

      })
      .then(resolve)
      .catch(reject);

  });

  return window.__slickLoading;
};